module.exports = __webpack_public_path__ + "static/media/banner-mobile@3x.9826c75c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/about-us/images/banner-mobile@3x.jpg
// module id = 1105
// module chunks = 2